import { AppRoutes } from '../common/constants';
import { Box, Card, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { JSX } from 'react';
import { LoadingButton } from '@mui/lab';
import { useCreateNewReport } from '../common/components/mutations';
import { useNavigate } from 'react-router-dom';
import Content from '../common/components/content';
import Layout from '../common/components/layout';
import Reports from './reports';

export const breadcrumbs = [{ label: 'Reports', href: AppRoutes.Reports }];

/**
 * Page with report list
 */
const ReportsPage = (): JSX.Element => {
  const { mutate, isPending } = useCreateNewReport();
  const navigate = useNavigate();

  const handleCreateReport = (): void => {
    mutate(
      {},
      {
        onSuccess: (data) => {
          navigate(`${AppRoutes.Reports}/${data.id}`);
        },
      },
    );
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Content>
        <Box className="flex items-center justify-between">
          <Typography variant="h2">Reports</Typography>
          <Box>
            <LoadingButton
              size="large"
              variant="contained"
              color="secondary"
              onClick={handleCreateReport}
              loading={isPending}
              endIcon={<Icon icon="uil:plus" />}
            >
              New
            </LoadingButton>
          </Box>
        </Box>
        <Card className="mt-4 pt-4">
          <Reports />
        </Card>
      </Content>
    </Layout>
  );
};
export default ReportsPage;
